/* 鍾繇（字元常） */
import { SG, gd, along, landing, spMul, sigOf } from '../../core/kit.ts';
import { defineHero, hook, U, S } from '../define.ts';

export default defineHero({
  id: 'zhongyao', name: '鍾繇', sub: '字元常', faction: 'wei', role: '輔助', weapon: 'staff',
  look: { wart: 'brush', weaponName: '紫毫筆', head: 'guan', robe: true, beard: 'long', hair: '#8a8a8a', fx: '#e8d8b0', c: { cloth: '#3a3a48', sleeve: '#3a3a48', trim: '#c9a24e', pole: '#2a2018' } },
  skills: [
    ['一筆', 'crescent', '在地上寫下一筆（長 {600/700/800/900}），持續 6 秒：友軍走在筆畫上移速 +20%，敵人走在上面緩速 40%。', { x: { k: 'stroke', w: 60, dur: 6, ms: 20, slow: 40 }, aim: { kind: 'dir', range: [600, 700, 800, 900], width: 60 }, cd: 14, mp: 80, el: null }],
    ['宣示表', 'shield', '指定一名友軍：清除減益並給予可吸收 {130/200/270/340} 傷害的護盾，持續 5 秒。', { x: { k: 'edict', amt: [130, 200, 270, 340], dur: 5 }, aim: U(600), cd: 12, mp: [70, 80, 90, 100] }],
    ['墨韻', 'passive', '站在「一筆」上的敵人受到的傷害 +{8/11/14/17}%。', { pv: {}, sig: 'ink', taken: [8, 11, 14, 17] }],
    ['送馬千匹', 'command', '全地圖友方武將移速 +{20/25/30}% 並解除緩速，持續 6 秒；期間下一次普攻會先衝到目標身邊。', { x: { k: 'horses', ms: [20, 25, 30], dur: 6 }, aim: S(0), cd: [110, 95, 80], mp: [150, 175, 200], el: 'wind', shout: '關中良馬二千，送至官渡！' }],
  ],
  // 專屬技能（技能資料裡的 x.k）
  kinds: {
    stroke(u, a, X) {
      const R = this.skillRange(a.sk, a.lvl), e = along(u.x, u.y, a.dir, R), ink = sigOf(u, 'ink');
      this.zone(u, { x: (u.x + e[0]) / 2, y: (u.y + e[1]) / 2, r: 0, t: X.dur, dur0: X.dur, tick: 9, name: a.sk.name,
        x2: { seg: [u.x, u.y, e[0], e[1]], w: X.w, ms: X.ms, slow: X.slow, ink: ink ? ink.v('taken') : 0 } });
    },
    edict(u, a, X) {
      const t = this.xAlly(u, a.pt, this.skillRange(a.sk, a.lvl), true);
      const s = t.st;
      s.slow = s.root = s.silence = s.disarm = s.stun = s.fear = s.taunt = s.charm = s.confuse = 0; t.dots = null; t.sleeping = false;
      if (t.buffs) t.buffs = t.buffs.filter((b: any) => !b.neg);
      this.addBuff(t, { id: 'edict', t: X.dur });
      s.shield = Math.max(s.shield, X.amt * spMul(u)); s.shieldT = Math.max(s.shieldT, X.dur);
      this.fx({ k: 'heal', x: t.x, y: t.y, col: '#ffe9a8' });
    },
    horses(u, a, X) {
      this.heroes(u.team).forEach((h) => {
        if (!h.alive) return;
        h.st.slow = 0; if (h.buffs) h.buffs = h.buffs.filter((b: any) => !(b.neg && b.ms < 0)); // 解除緩速：技能、光環、毒的緩速增益也清掉
        this.addBuff(h, { id: 'horses', t: X.dur, ms: X.ms / 100 }); h.horseT = this.t + X.dur;
        this.fx({ k: 'heal', x: h.x, y: h.y, col: '#9ff0c8' });
      });
      this.say(`${u.name}：送馬千匹！全軍加速`, 'info', u.team);
    },
  },
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 一筆：線段區域，友軍加速、敵人減速並易傷
    hook('zone', 10, function (z, dt) {
      const e = z.x2;
      if (e.seg) {
        for (const t of this.units) {
          if (!t.alive || t.structure || t.kind === 'ward' || t.kind === 'cart' || SG.segDist(t.x, t.y, e.seg) > e.w / 2 + t.r * 0.5) continue;
          if (t.team === z.team) this.addBuff(t, { id: 'stroke', t: 0.3, ms: e.ms / 100 });
          else if (t.team < 2) this.addBuff(t, { id: 'stroke', t: 0.3, neg: true, ms: -e.slow / 100, taken: e.ink / 100 });
        }
        return true;
      }
    }),
    // 送馬千匹：追擊時衝到目標身邊
    hook('goToward.pre', 10, function (u, x, y, dt) {
      const t = u.input && u.input.target;
      if (u.horseT > this.t && t && t.alive && t.team !== u.team && u.st.root <= 0) {
        const d = gd(u.x, u.y, t.x, t.y);
        if (d > u.range + t.r && d < 650) {
          const dir = SG.dirTo(u, t.x, t.y), q = landing(u.x, u.y, ...along(t.x, t.y, [-dir[0], -dir[1]], u.range * 0.6 + t.r));
          this.fx({ k: 'puff', x: u.x, y: u.y }); u.x = q[0]; u.y = q[1]; u.horseT = 0; this.fx({ k: 'spark', x: u.x, y: u.y - 30, col: '#9ff0c8' });
          return true;
        }
      }
    }),
    hook('revive', 70, function (u) { u.horseT = 0; }),
  ],
  // 電腦什麼時候放這招
  ai: {
    stroke: ({ w, u, t, d, hero, hpR, foeHeroes }) => hero && d < 600,
    edict: ({ w, u, t, d, hero, hpR, foeHeroes }) => w.units.some((o) => o.alive && o.team === u.team && o.kind === 'hero' && o.hp / o.maxHp < 0.6 && gd(u.x, u.y, o.x, o.y) < 650),
    horses: ({ w, u, t, d, hero, hpR, foeHeroes }) => hero && d < 700 && w.heroes(u.team).filter((h) => h.alive && gd(u.x, u.y, h.x, h.y) < 900).length >= 2,
  },
});
